<div class="custom-input-wrapper">
  <label *ngIf="label" class="custom-label">{{ label }}</label>
  <div
    class="custom-radio-group"
    [class.is-disabled]="disabled"
    [class.is-readonly]="readonly"
    [style.grid-template-columns]="'repeat(' + columns + ', minmax(0, 1fr))'"
  >
    <button
      *ngFor="let option of options; trackBy: trackByValue"
      type="button"
      class="custom-radio-option"
      [class.is-selected]="isSelected(option.value)"
      [disabled]="disabled || readonly"
      [attr.aria-pressed]="isSelected(option.value)"
      (click)="select(option.value)"
    >
      <span class="custom-radio-dot"></span>
      <span>{{ option.label }}</span>
    </button>
  </div>
</div>
